import React, { useEffect, useRef, useState } from "react";
import Frame1 from "../../assets/Frame1.png";
import Frame2 from "../../assets/Frame2.png";
import Frame3 from "../../assets/Frame3.png";

import {
  RightOutlined,
  LeftOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Rate, Button, Tabs } from "antd";
import "antd/dist/reset.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchTestimonials } from "../../redux/testimonialSlice";

const { TabPane } = Tabs;

const Preview = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const { testimonials, status, error } = useSelector(
    (state) => state.testimonials
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchTestimonials());
    }
  }, [status, dispatch]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1280);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [activeTab, setActiveTab] = useState("1");
  const swiperRef = useRef(null);

  const handleTabChange = (key) => {
    setActiveTab(key);
    swiperRef.current?.slideTo(Number(key) - 1);
  };

  const handleSlideChange = (swiper) => {
    setActiveTab(String(swiper.activeIndex + 1));
  };

  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  return (
    <div className="relative Preview mb-7" dir="ltr">
      <div className="bg-[#14294F] relative">
        <div className="px-20 max-lg:px-5">
          <img src={Frame1} className="w-[350px] absolute left-0 top-0 z-0" />
          <img
            src={Frame2}
            className="w-[400px] absolute right-0 top-0 z-0 max-lg:hidden"
          />
          <div
            dir={language === "en" ? "ltr" : "rtl"}
            className="grid grid-cols-3 max-lg:grid-cols-1 gap-10 mt-8 py-20 lg:items-center relative z-10"
          >
            <div className="col-span-2">
              <h3 className="text-[#F16622] text-2xl font-semibold">
                {t("requestPreview")}
              </h3>
              <p className="text-[#F3F5F7] text-lg mt-3">
                {t("Get your detailed property assessment from industry leaders, empowering you to make informed decisions for your projects.")}
              </p>
            </div>
            <div className="mx-auto">
              <Link
                to="/previewrequests"
                className="text-[#FE9B71] rounded-full border-4 border-[#F16622] w-[250px] h-[50px] text-xl flex items-center justify-center"
              >
                {t("requestNow")}
                {language == "en" ? (
                  <RightOutlined className="ml-8 font-bold" />
                ) : (
                  <LeftOutlined className="mr-8 font-bold" />
                )}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-10">
        <div
          className="bg-[#14294F]"
          style={{ borderRadius: "0px 0px 180px 0px" }}
        >
          <img
            src={Frame3}
            className="w-[350px] absolute left-0 -bottom-5 z-0 max-lg:hidden"
          />
          <div
            dir={language === "en" ? "ltr" : "rtl"}
            className="pl-20 pr-10 max-lg:pl-5 max-lg:pr-5 lg:py-44 max-lg:py-10 my-2 relative z-10 max-lg:text-center"
          >
            <h3 className="text-[#F16622] text-3xl max-lg:text-2xl font-semibold">
              {t("testimonialsTitle")}
            </h3>
            <p className="text-[#F3F5F7] text-2xl max-lg:text-xl mt-3">
              {t("testimonialsSubtitle")}
            </p>
          </div>
        </div>

        <div className="lg:col-span-2 lg:py-10 lg:px-14 max-lg:px-5 lg:flex relative">
          {status === "loading" && <p>{t("loading")}</p>}
          {status === "failed" && <p>{t("errorFetchingTestimonials")}</p>}

          {testimonials?.length > 0 && (
            <>
              {/* <Button
                icon={<UpOutlined />}
                type="text"
                className="swiper-button-prev absolute right-10 top-5 text-[#EAA182] max-lg:hidden"
                onClick={handlePrev}
              /> */}

              <Swiper
                modules={[Navigation]}
                navigation={{
                  prevEl: ".swiper-button-prev",
                  nextEl: ".swiper-button-next",
                }}
                spaceBetween={50}
                slidesPerView={1}
                pagination={{ clickable: true }}
                onSlideChange={handleSlideChange}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                className="h-full"
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <div className="bg-[#FCFBFA] py-14 px-10 border-2 border-[#EAA182] shadow-lg rounded-3xl text-center max-w-md">
                      <p className="text-[#737E91] mb-4">
                        {testimonial.rate_comment}
                      </p>
                      <p className="text-[#283D63] text-lg mb-2 mt-8 font-semibold">
                        {testimonial.title}
                      </p>
                      <Rate
                        disabled
                        defaultValue={testimonial.rate}
                        className="mb-2"
                      />
                      <p className="font-bold text-[#14294F] text-xl mt-6">
                        {testimonial?.user?.name == null ? "User" : testimonial?.user?.name}
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* <Button
                icon={<DownOutlined />}
                type="text"
                className="swiper-button-next absolute right-10 bottom-10 text-[#EAA182] max-lg:hidden"
                onClick={handleNext}
              /> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Preview;
